import script from "./GastoFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./GastoFormView.vue?vue&type=script&setup=true&lang=js"

import "./GastoFormView.vue?vue&type=style&index=0&id=4010e020&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4010e020"]])

export default __exports__